module.exports = __webpack_public_path__ + "static/media/alicorn.bdb28bd1.svg";